import Component from 'flarum/common/Component';
import Stream from 'flarum/utils/Stream';
import Button from 'flarum/common/components/Button';

import UploadComponent from './UploadComponent';

export default class QueryManagementComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.infoQueryData = this.attrs.targetData;
    this.editMode = this.attrs.editMode;
    this.infoBaseData = this.infoQueryData.u2diBaseData();
    this.infoDetailsData = this.infoQueryData.u2diDetailsData();
    this.infoID = this.infoBaseData.id();
    this.queryID = this.infoQueryData.id();
    this.queryContacted = Stream(this.infoQueryData.contacted());
    this.queryCompleted = Stream(this.infoQueryData.completed());
    this.queryNote = Stream(this.infoQueryData.note());
    this.infoReports = this.infoBaseData.reports();
    this.infoStatus = Stream(this.infoBaseData.status());
    this.infoStatusOriginal = this.infoBaseData.status();
    this.infoPrice = Stream(this.infoStatus()===1?this.infoBaseData.price():"");
    
    this.selectedType = this.infoBaseData.category();
    this.jjxx = JSON.parse(this.infoDetailsData.jjxx());
    this.option_crxs = this.jjxx.option_crxs;

    let attachment = this.infoBaseData.attachment();
    if(attachment===""){
      attachment = [];
    }

    this.infoAttachment = Stream(typeof(attachment)==="string"?JSON.parse(attachment):attachment);

    let queryAttachment = this.infoQueryData.attachment();
    if(queryAttachment===""){
      queryAttachment = [];
    }

    this.queryAttachment = Stream(typeof(queryAttachment)==="string"?JSON.parse(queryAttachment):queryAttachment);

    this.loading = false;
    this.modified = true;

  }

  onupdate(){
    if(this.editMode!==this.attrs.editMode){
      this.editMode = this.attrs.editMode;
      m.redraw();
    }
  }

  onPageReady(vnode) {
    const _this = this;

    $("#option_ysx").change(function() {
      _this.infoStatus(this.checked===true?2:_this.infoStatusOriginal);

      if(this.checked===true){
        _this.infoPrice("");
      }

      m.redraw();
    }); 

    $("#u2diContacted"+this.queryID).change(function(e) {
      _this.queryContacted(_this.queryContacted()==1?0:1);
    }); 

    $("#u2diCompleted"+this.queryID).change(function(e) {
      _this.queryCompleted(_this.queryCompleted()==1?0:1);
    }); 
  }

  view() {
    const _this = this;
    const infoStatus = this.infoBaseData.status();
    let reportType = null;

    if(this.infoReports>0){
      const reportData = this.infoQueryData.u2diReportData();
      reportType = reportData[reportData.length-1].type();
    }

    return (
      <div style="text-align:center">
        <div style="text-align:left" oncreate={this.onPageReady.bind(this)}>
          <div className="u2diUserSubmitCategoryName">{app.translator.trans('ziven-u2di.forum.user-submission-category-gljl')}</div>

          <div style="padding-bottom: 15px;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <div style="text-align: left;display: flex;">
                <input disabled={this.loading || this.editMode===false} style="cursor:pointer" id={"u2diContacted"+this.queryID} type="checkbox" value={this.queryContacted()} checked={this.queryContacted()==1?"checked":""} />
                <label style="margin-left: 5px;" for={"u2diContacted"+this.queryID}>{app.translator.trans('ziven-u2di.forum.item-contacted')}</label>
                <input disabled={this.loading || this.editMode===false} style="cursor:pointer;margin-left: 10px;" id={"u2diCompleted"+this.queryID} type="checkbox" value={this.queryCompleted()} checked={this.queryCompleted()==1?"checked":""} />
                <label style="margin-left: 5px;" for={"u2diCompleted"+this.queryID}>{app.translator.trans('ziven-u2di.forum.item-completed')}</label>
              </div>
            </div>
          </div>

          <div className="u2diUserSubmitCategoryItems" style="align-items: flex-start;">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-xdbj')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions" style="width: 65%;">
              <textarea disabled={this.loading || this.editMode===false} style="height: 80px;" className="FormControl" bidi={this.queryNote} />
            </div>
          </div>
        
          <div>
            <div className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-cjjg')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <input disabled={this.loading || this.editMode===false || infoStatus!=0} className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.infoPrice} />
               
                {this.selectedType==="tdwz" && (
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-mu')}</span>
                )}

                {this.selectedType==="jzwz" && this.option_crxs==="zz" && (
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-year')}</span>
                )}

                {this.selectedType==="jzwz" && this.option_crxs!=="zz" && (
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-squre-meter')}</span>
                )}

                <input disabled={this.loading || this.editMode===false || infoStatus!=0} className="u2diUserSubmitCategoryItemRadio" id="option_ysx" type="checkbox" value="0" checked={this.infoStatus()==2?"checked":""} /><label style="margin-left: 5px;" for="option_ysx">{app.translator.trans('ziven-u2di.forum.user-submission-category-item-ysx')}</label>
              </div>
            </div>
            {this.infoReports>0 && (
              <div className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName">
                </div>
                <div className="u2diUserSubmitCategoryItemOptions">
                  <div style={reportType===2?"background:#c82a29":"background:orange !important"} className="u2diLabelRed u2diUserSubmitInvalidReminder">{app.translator.trans('ziven-u2di.forum.item-report-'+reportType+'-reminder')}</div>
                </div>
              </div>
            )}
          </div>

          <div className="u2diUserSubmitCategoryItems" style="align-items: baseline;padding-top: 5px;">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-fjtp')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <UploadComponent uploadType="wjzl" viewType={this.editMode===true?"edit":"read"} uploadTarget={this.infoAttachment} uploadCallback={function(result,option_target){
                _this.infoAttachment = option_target;
                // _this.modified = true;
              }} />
            </div>
          </div>

          {this.editMode===true && (
            <div className="u2diManagementButtonsContainer" style="text-align: center;">
              {Button.component({
                  className: 'Button Button--primary',
                  disabled: this.modified===false,
                  onclick: (e) => {
                    this.updateInfo(e);
                  }
                },
                app.translator.trans('ziven-u2di.lib.save-manage')
              )}&nbsp;
              {Button.component({
                  style: "display:none",
                  className: 'Button Button--primary',
                  onclick: (e) => {
                    this.downloadPDF(e);
                  }
                },
                app.translator.trans('下载完整PDF')
              )}
            </div>
          )}

        </div>
      </div>
    );
  }

  downloadPDF() {
      $(".u2diManagementButtonsContainer").hide();

      const { jsPDF } = window.jspdf;
      const element = $(".Modal-content form");
      const width = element.width();
      const height = element.height();
      let doc = new jsPDF('p', 'mm', [width, height]);
      
      // const myFont = '';

      // doc.addFileToVFS("MyFont.ttf", myFont);
      // doc.addFont("MyFont.ttf", "MyFont", "normal");
      // doc.setFont("MyFont");

      doc.html(element[0], {
          callback: function () {
              // doc.save('test.pdf');
              window.open(doc.output('bloburl')); // use this to debug
              $(".u2diManagementButtonsContainer").show();
          }
      });
  }

  updateInfo(e) {
    e.preventDefault();

    this.loading = true;

    let price = this.infoPrice();
    let updateData = {
      contacted:this.queryContacted(),
      completed:this.queryCompleted(),
      note:this.queryNote(),
      attachment:this.queryAttachment(),
      status: this.infoStatus(),
    };

    if(price!==""){
      updateData.price = price;
    }

    this.infoQueryData.save(updateData)
    .then(() => {
        this.loading = false;
        // this.modified = false;
        m.redraw();
      },
      (response) => {
        this.loading = false;
      }
    );
  }
}